module.exports = __webpack_public_path__ + "img/list_pl.af5ac12c.svg";